import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AboutSection } from './components/AboutSection';
import { TeamSection } from './components/TeamSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { CookieScriptLoader } from './components/CookieScriptLoader';
import { GoogleTagLoader } from './components/GoogleTagLoader';
export function App() {
  return <div className="w-full min-h-screen font-sans text-gray-900" data-id="element-0">
      <CookieScriptLoader data-id="element-1" />
      <GoogleTagLoader data-id="element-2" />
      <Header data-id="element-3" />
      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <CaseStudiesSection data-id="element-7" />
        <AboutSection data-id="element-8" />
        <TeamSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <ContactSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}